module.exports = __webpack_public_path__ + "img/done.2fd43da7.png";